import { render, staticRenderFns } from "./capa.vue?vue&type=template&id=76637dde&"
import script from "./capa.vue?vue&type=script&lang=js&"
export * from "./capa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports